// import {ApiService, AuthenticationMethod, HttpMethod} from "@amzn/wish-web-core-common/dist/http";
import {baseUrl} from "./ApiEndpoints";
import {ApiService} from "./http/FederateApi.service";

export class FeedbackApiService extends ApiService {

    constructor() {
        super({
            baseUrl
        })
    }

    private urls = {
        feedback: "/feedback/",
    }

    addFeedback(feedbackType, login, comment, contact) {
        return super.post(
            this.urls.feedback,
            {"feedbackType":feedbackType, "login": login, "comment": comment, "contact": contact}
        )
    }
}
